import { ValidationModel, ValidationType } from "@/services/validation/types";

export const playerValidators = {
    name: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel
};
